module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('span', [_vm._v("Also in Arrow by Evelyn Anthony")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("Albatross")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("The Assassin")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("The Avenue of the Dead")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("The Company of Saints")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("The Defector")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("The Legend")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("The Malaspiga Exit")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("The Occupying Power")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("The Poellenberg Inheritance")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("The Rendezvous")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("The Return")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', [_c('i', [_vm._v("No Enemy But Time")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 60
// module chunks = 0